import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';
import COPY from './broschureCopy';

/**
 * Broschüre CTA — dedicated slide with a large centered QR code that opens
 * the STIG GROUP brochure.  Two-column layout: brochure cover + QR panel
 * on the left, marketing copy on the right.  Copy is localised for all
 * 29 languages via `broschureCopy.js`.
 */
export default function SectionBroschure() {
  const { lang } = useT();
  const c = COPY[lang] || COPY.en;

  return (
    <SectionShell
      id="broschure"
      fullBleed
      data-testid="section-broschure"
    >
      <div className="broschure-shell">
        <div className="broschure-grid">
          {/* LEFT — brochure cover + QR */}
          <div className="broschure-visuals">
            <Reveal delay={120}>
              <div className="broschure-cover-wrap" data-testid="broschure-cover">
                <img
                  src="/brochure-cover.png"
                  alt="STIG GROUP Broschüre"
                  className="broschure-cover-img"
                  loading="lazy"
                  draggable={false}
                />
              </div>
            </Reveal>

            <Reveal delay={200}>
              <a
                href="https://stiggroup.com"
                target="_blank"
                rel="noopener noreferrer"
                className="broschure-qr-link"
                data-testid="broschure-qr"
                aria-label={c.title}
              >
                <div className="broschure-qr-frame">
                  <img
                    src="/qr-broschure.png"
                    alt="QR-Code — STIG GROUP Broschüre"
                    loading="lazy"
                    draggable={false}
                    className="broschure-qr-img"
                  />
                </div>
              </a>
            </Reveal>
          </div>

          {/* RIGHT — copy */}
          <div className="broschure-copy">
            <Reveal>
              <div
                className="overline broschure-overline"
                data-testid="broschure-overline"
              >
                {c.over}
              </div>
            </Reveal>

            <Reveal delay={140}>
              <h2
                className="broschure-title font-display"
                data-testid="broschure-title"
              >
                {c.title}
              </h2>
            </Reveal>

            <Reveal delay={240}>
              <p
                className="broschure-body font-ui"
                data-testid="broschure-body"
              >
                {c.body}
              </p>
            </Reveal>

            <Reveal delay={320}>
              <ul
                className="broschure-checks"
                data-testid="broschure-checks"
              >
                {c.checks.map((item, i) => (
                  <li key={i} className="broschure-check-item">
                    <span className="broschure-check-mark" aria-hidden="true">
                      ✓
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={420}>
              <p
                className="broschure-outro font-display"
                data-testid="broschure-outro"
              >
                {c.outro}
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}
